import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";

export const CollapsibleRoot = CollapsiblePrimitive.Root;
